
// Fichier : assets/datalayer.js
document.addEventListener("DOMContentLoaded", function () {
  window.dataLayer = window.dataLayer || [];

  /**
   * view_item – page produit
   */
  function getProductData() {
    if (
      typeof ShopifyAnalytics === "undefined" ||
      !ShopifyAnalytics.meta ||
      !ShopifyAnalytics.meta.product
    ) return null;

    const product = ShopifyAnalytics.meta.product;
    return {
      item_name: product.name || product.title,
      item_id: product.sku || product.id,
      price: product.price,
      quantity: 1,
      item_brand: "Woodstache",
      item_variant: product.variants?.[0]?.name || "",
      item_category: product.type || "",
    };
  }

  if (
    ShopifyAnalytics.meta?.page?.pageType === "product"
  ) {
    const productData = getProductData();
    if (productData) {
      console.log("📌 view_item déclenché", productData);
      dataLayer.push({
        event: "view_item",
        ecommerce: {
          currency: ShopifyAnalytics.meta.currency || "EUR",
          value: productData.price,
          items: [productData],
        },
      });
    }
  }

  /**
   * select_item – clic sur un produit depuis une liste (collection, best sellers…)
   */
  document.querySelectorAll('[data-product-id], .product-grid__item').forEach(el => {
    el.addEventListener("click", () => {
      const name = el.querySelector('[data-product-title]')?.textContent?.trim() || el.getAttribute('data-product-title') || "Produit inconnu";
      const id = el.getAttribute('data-product-id') || "inconnu";
      console.log("📌 select_item déclenché", name, id);
      dataLayer.push({
        event: "select_item",
        ecommerce: {
          items: [{
            item_name: name,
            item_id: id,
            item_brand: "Woodstache"
          }]
        }
      });
    });
  });

  /**
   * view_cart – page panier
   */
  if (window.location.pathname === "/cart") {
    console.log("📌 view_cart déclenché");
    dataLayer.push({ event: "view_cart" });
  }

  /**
   * add_to_cart – interception fetch
   */
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = args[0];
    const options = args[1] || {};
    if (typeof url === 'string' && url.includes('/cart/add') && options.method === 'POST') {
      try {
        const response = await originalFetch.apply(this, args);
        const result = await response.clone().json();
        console.log("📌 add_to_cart déclenché", result);
        dataLayer.push({
          event: "add_to_cart",
          ecommerce: {
            currency: "EUR",
            value: parseFloat(result.price) / 100,
            items: [{
              item_name: result.product_title,
              item_id: result.variant_id,
              price: parseFloat(result.price) / 100,
              quantity: result.quantity || 1,
              item_brand: "Woodstache",
              item_variant: result.variant_title || "",
              item_category: result.product_type || ""
            }]
          }
        });
        return response;
      } catch (err) {
        console.warn("⚠️ add_to_cart error", err);
        return originalFetch.apply(this, args);
      }
    }
    return originalFetch.apply(this, args);
  };

  /**
   * remove_from_cart – suppression ou maj à 0
   */
  document.querySelectorAll('[name^="updates"]').forEach((input) => {
    input.addEventListener("change", function () {
      const newQuantity = parseInt(this.value);
      if (newQuantity === 0) {
        const row = this.closest(".cart__row, .cart__item");
        const title = row?.querySelector(".cart__product-name")?.textContent || "";
        const sku = row?.dataset?.sku || "";
        const price = parseFloat(row?.dataset?.price) || 0;
        console.log("📌 remove_from_cart déclenché", { title, sku, price });
        dataLayer.push({
          event: "remove_from_cart",
          ecommerce: {
            currency: "EUR",
            value: price,
            items: [{
              item_name: title,
              item_id: sku,
              price: price,
              quantity: 1,
              item_brand: "Woodstache",
            }]
          }
        });
      }
    });
  });

  /**
   * begin_checkout – submit form
   */
  const checkoutForm = document.querySelector('form[action^="/checkout"]');
  if (checkoutForm) {
    checkoutForm.addEventListener("submit", function () {
      const cartItems = ShopifyAnalytics?.meta?.cart?.line_items || [];
      const items = cartItems.map((item) => ({
        item_name: item.product_title,
        item_id: item.sku,
        price: item.line_price / 100,
        quantity: item.quantity,
        item_brand: "Woodstache",
      }));
      const total = ShopifyAnalytics?.meta?.cart?.total_price / 100;
      console.log("📌 begin_checkout déclenché", items);
      dataLayer.push({
        event: "begin_checkout",
        ecommerce: {
          currency: ShopifyAnalytics.meta.currency || "EUR",
          value: total,
          items: items,
        },
      });
    });
  }

  /**
   * add_shipping_info – checkout étape livraison
   */
  if (Shopify && Shopify.Checkout && Shopify.Checkout.step === "shipping_method") {
    console.log("📌 add_shipping_info déclenché");
    dataLayer.push({ event: "add_shipping_info" });
  }

  /**
   * add_payment_info – checkout étape paiement
   */
  if (Shopify && Shopify.Checkout && Shopify.Checkout.step === "payment_method") {
    console.log("📌 add_payment_info déclenché");
    dataLayer.push({ event: "add_payment_info" });
  }

  /**
   * purchase – page de remerciement
   */
  if (window.Shopify && Shopify.checkout && Shopify.checkout.line_items) {
    try {
      const order = Shopify.checkout;
      const items = order.line_items.map((item) => ({
        item_name: item.title,
        item_id: item.variant_id,
        price: parseFloat(item.price),
        quantity: item.quantity,
        item_brand: "Woodstache",
        item_variant: item.variant_title || "",
        item_category: item.product_type || ""
      }));
      console.log("📌 purchase déclenché", items);
      dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: order.order_id || order.id,
          affiliation: "Shopify",
          value: parseFloat(order.total_price),
          currency: order.currency,
          tax: parseFloat(order.total_tax),
          shipping: parseFloat(order.shipping_price || 0),
          items: items
        }
      });
    } catch (e) {
      console.warn("⚠️ Erreur purchase :", e);
    }
  }
});
